import axios from 'axios';
// import store from '../store'

export default function setup() {
    axios.interceptors.request.use(
        function (config) {

            return config;

        });
}